import _createClass from "/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export var LoaderError = /*#__PURE__*/function (_Error) {
  _inherits(LoaderError, _Error);

  var _super = _createSuper(LoaderError);

  function LoaderError(id, error) {
    var _this;

    _classCallCheck(this, LoaderError);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "nativeError", void 0);

    _this.message = "Failed to load module ".concat(id);
    _this.name = 'LoaderError';
    _this.nativeError = error;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), LoaderError);
    }

    return _this;
  }

  return _createClass(LoaderError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var isLoaderError = function isLoaderError(error) {
  return error instanceof LoaderError;
};